import { createFileRoute } from "@tanstack/react-router"
import { EditDonationPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Action, Resource } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/donations/pages/$pageUuid/edit"
)({
  component: function EditDonationPageRoute() {
    return (
      <AuthorizationGate resource={Resource.DONATION} action={Action.UPDATE}>
        <EditDonationPage />
      </AuthorizationGate>
    )
  },
})
